
export class NivelDelegado{
    otorgadoPor: string;
    fechaDesde: string;
    fechaHasta: string;
    codigoNivelAprobacion: string;
    detalle: string;
}
